import { AxiosRequestConfig } from "axios";
import { AXIOS_INSTANCE, BASE_URL } from "../App";

export default async function GetDriverNotes(salesOrg: string): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
    },
    data: {
        "filters":{
            "deliveringPlant": "A001",
            "showAll":"TRUE"
        }
    },
    url: `${BASE_URL}/api/notes/driver`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}
